import React from 'react';
import { cn } from '@/utils';
import type { ReviewType } from '../review/review';
import Review from '../review/review';

type CardReviewProps = React.HTMLAttributes<HTMLDivElement> & ReviewType;

const CardReview = React.forwardRef<HTMLDivElement, CardReviewProps>(
  ({ className, children, ...review }, ref) => (
    <div ref={ref} className={cn('rounded-medium bg-content2 shadow-small p-5', className)}>
      <Review {...review} />
      {children}
    </div>
  ),
);

CardReview.displayName = 'CardReview';

export default CardReview;
